export const ACTIVE = 'active';
export const COMPLETED = 'completed';
export const ONGOING = 'ongoing';
export const HISTORY = 'history';



// WEBPACK FOOTER //
// ./src/constants/questionListTabNames.js